module.exports = __webpack_public_path__ + "static/media/infoGauge.1c3fb491.svg";